<template>
  <div>
    <div v-if="alert" class="danger tw-mx-5 alert-container">
      <span class="mx-3">
        <b> ⚠️ แจ้งเตือนสำคัญ: หนังสือรับรอง (Certificate) ของท่านใกล้หมดอายุ  </b>
        <br />
        เพื่อป้องกันผลกระทบต่อการยื่นข้อมูลกับกรมสรรพากรและให้การใช้งานระบบเป็นไปอย่างต่อเนื่อง
        <br />
        โปรดดาวน์โหลดไฟล์ XML ภายในวันที่ {{ expireDate }}
        <br />
        และกรุณาติดต่อเจ้าหน้าที่ฝ่ายขายล่วงหน้า 3-4 สัปดาห์ก่อนวันหมดอายุ เพื่อดำเนินการต่ออายุหนังสือรับรองของท่าน
        <p class="ml-2">
        </p>
      </span>
      <v-icon color="#fff" class="mx-2" @click="alert = false">
        mdi-close-circle-outline
      </v-icon>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "AlertCertExpire",
  components: {},
  computed: mapState({
    listKey: (state) => state.keyByCompany.listKey,
    selectedCompany: (state) => state.companies.selectedCompany,
  }),
  created() {
    this.query();
  },
  data: () => ({
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "หนังสือรับรอง",
        disabled: true,
      },
    ],
    dialog: false,
    alert: false,
    expireDate: null,
  }),
  mounted() {
    this.alertToken();
  },
  watch: {
    listKey: {
      handler: function () {
        this.alertToken();
      },
    },
  },
  beforeDestroy() {
    this.$store.dispatch("keyByCompany/getCerListUnsubscribe");
  },
  methods: {
    query: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("keyByCompany/getList", { companyId });
      }
    },
    checkExpireDate: function (endDate) {
      let date = moment.unix(endDate.seconds);
      if (date.toDate()) {
        return date.toDate() > new Date();
      }
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate())
          .add(543, "years")
          .format("Do MMM YY, LTS");
      }
      return "-";
    },
    getNameIssuer: function (nameIssuer) {
      let name = "-";
      if (nameIssuer && nameIssuer.CN) {
        name = nameIssuer.CN;
      }
      if (nameIssuer && nameIssuer.O) {
        name = `${name} (${nameIssuer.O})`;
      }
      return name;
    },
    getNameSubject: function (nameSubject) {
      let name = "-";
      if (nameSubject && nameSubject.CN) {
        name = nameSubject.CN;
      }
      if (nameSubject && nameSubject["2.5.4.97"]) {
        name = `${name} (${nameSubject["2.5.4.97"]})`;
      }
      return name;
    },
    alertToken: function () {
      moment.locale("th");

      if (!Array.isArray(this.listKey) || this.listKey.length === 0) {
        this.alert = false;
        this.expireDate = null;
        return;
      }

      const now = new Date();

      // filter เฉพาะ cer ที่ยังไม่หมดอายุ และคำนวณ daysDiff ไว้เลย
      const validKeys = this.listKey
        .filter((key) => key?.timeNotAfter?.seconds)
        .map((key) => {
          const expireDate = moment.unix(key.timeNotAfter.seconds);
          const daysDiff = expireDate.diff(now, "days");
          return { ...key, expireDate, daysDiff };
        })
        .filter((key) => key.daysDiff >= 0);

      if (validKeys.length === 0) {
        this.alert = false;
        this.expireDate = null;
        return;
      }

      // เช็คว่า cert ทุกตัวเหลือ <= 30 วันหรือไม่
      const allExpiringSoon = validKeys.every((key) => key.daysDiff <= 30);

      if (!allExpiringSoon) {
        // มี cert ที่เหลือมากกว่า 30 วัน ไม่ต้องแสดง alert
        this.alert = false;
        this.expireDate = null;
        return;
      }

      // หา cert ที่หมดอายุเร็วสุดเพื่อแสดงวันที่
      const soonestExpire = validKeys.reduce((min, key) =>
        key.daysDiff < min.daysDiff ? key : min
      );

      this.expireDate = soonestExpire.expireDate.clone().add(543, "years").format("Do MMM YYYY, LTS");
      this.alert = true;
    },
  },
};
</script>

<style lang="scss">
.danger {
  min-width: 450px;
  height: 105px;
  background-color: #c9242b;
  position: absolute;
  border-radius: 0 0 15px 15px !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 13.5px;
  left: 245px;

  @media only screen and (max-width: 700px) {
    border-radius: 10px;
  }
}

.v-card > *:last-child:not(.v-btn):not(.v-chip) {
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 0;

  @media only screen and (max-width: 700px) {
    border-radius: 10px;
  }
}
</style>